

export default function TextYouWont(){
    return(
      <p className="text-sm text-center pb-6">Your won't be charged yet</p>

    )
}